import React from "react";
import { Modal } from "./Modal";
import { Button } from "../Button/Button";
import styles from "./ConfirmModal.module.css";

export interface ConfirmModalProps {
  /** Controla a visibilidade do modal */
  visible: boolean;
  /** Callback chamado ao fechar ou cancelar */
  onHide: () => void;
  /** Callback chamado ao confirmar a ação */
  onAccept: () => void;
  /** Título do modal @default "Confirmação" */
  header?: string;
  /** Mensagem de confirmação */
  message: string;
  /** Texto do botão de confirmação @default "Sim" */
  acceptLabel?: string;
  /** Texto do botão de cancelamento @default "Não" */
  rejectLabel?: string;
  /** Severidade do botão de confirmação @default "danger" */
  severity?: "danger" | "success" | "primary" | "secondary";
  /** Ícone do botão de confirmação @default "check" */
  acceptIcon?: string;
  /** Indica se a ação está em processamento */
  loading?: boolean;
}

/**
 * ConfirmModal Component
 * 
 * Componente especializado para diálogos de confirmação (ex: exclusão).
 * Substitui o uso do `ConfirmDialog` do PrimeReact.
 */
export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  visible,
  onHide,
  onAccept,
  header = "Confirmação",
  message,
  acceptLabel = "Sim",
  rejectLabel = "Não",
  severity = "danger",
  acceptIcon = "check",
  loading = false,
}) => {
  const footer = (
    <div className={styles.footer}>
      <Button
        label={rejectLabel}
        variant="outlined"
        severity="secondary"
        onClick={onHide}
        disabled={loading}
      />
      <Button
        label={acceptLabel}
        icon={acceptIcon}
        severity={severity}
        onClick={onAccept}
        loading={loading}
      />
    </div>
  );

  return (
    <Modal
      visible={visible}
      onHide={onHide}
      header={header}
      footer={footer}
      size="sm"
    >
      <div className={styles.confirmContent}>
        <p className={styles.message}>{message}</p>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
